import { ofType } from 'redux-observable';
import type { Observable } from 'rxjs';
import { combineLatest } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import type { Action } from 'state/actions';
import { isDashboardWorkspace } from 'state/quotes/infos/infos.model';
import type { EpicWithThunk, Thunk } from 'state/state.common';
import { workspaceHideDashboard } from 'state/workspaces/workspaces/workspace.actions';

export function waitUntilUserIsLoaded(action$: Observable<Action>, result$: Observable<Action | Thunk<void>>) {
  const userInfoReceived$ = action$.pipe(ofType('USER_CURRENT_RECEIVED'));
  return combineLatest([result$, userInfoReceived$]).pipe(map(([a, _]) => a));
}

export function hideDashboardWhenRepriceEpic(): EpicWithThunk {
  return (action$, _state$) => {
    const result$ = action$.pipe(
      ofType('WORKSPACE_TAB_QUOTE_REPRICED', 'WORKSPACE_RFQ_LOAD_REQUESTED'),
      filter(({ workspace }) => isDashboardWorkspace(workspace)),
      map(({ workspace }) => workspaceHideDashboard(workspace)),
    );
    return waitUntilUserIsLoaded(action$, result$);
  };
}
